"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePayData = void 0;
const luxon_1 = require("luxon");
const react_query_1 = require("react-query");
const fetchClient_1 = require("../../client/fetchClient");
const paths_1 = require("../../paths");
const DateManagement_1 = require("../../utils/DateManagement");
const EventEmitter_1 = require("../../utils/EventEmitter");
const taaConfigs_1 = require("../../contexts/taaConfigs");
const usePayData = ({ employeeId, timeZone, payPeriodBreakdownInfo, shouldFetch, usageLocation }) => {
    const { host, clientName, currentStage } = (0, taaConfigs_1.useTaaConfigsContext)();
    const ApiPath = (0, paths_1.GET_PAY_DATA_API)(employeeId, luxon_1.DateTime.fromISO(payPeriodBreakdownInfo === null || payPeriodBreakdownInfo === void 0 ? void 0 : payPeriodBreakdownInfo.current.start_time)
        .setZone(timeZone)
        .toISODate(), luxon_1.DateTime.fromISO(payPeriodBreakdownInfo === null || payPeriodBreakdownInfo === void 0 ? void 0 : payPeriodBreakdownInfo.current.end_time)
        .setZone(timeZone)
        .toISODate());
    const { isLoading: isGetPayDataLoading, data: getPayDataResponse } = (0, react_query_1.useQuery)(['payData', ApiPath], () => (0, fetchClient_1.getData)({
        path: ApiPath,
        host,
        eventName: EventEmitter_1.taaEvents.GET_PAY_DATA,
        metaData: {
            apiName: 'getPayData',
            clientName
        },
        usageLocation
    }, currentStage), {
        enabled: !!employeeId && !!payPeriodBreakdownInfo && shouldFetch,
        staleTime: 60 * 1000,
        retry: false
    });
    const payDataItemsByDate = getPayDataItemsByDate(getPayDataResponse, timeZone);
    return {
        isGetPayDataLoading,
        payDataItemsByDate,
        errorMessage: getPayDataResponse === null || getPayDataResponse === void 0 ? void 0 : getPayDataResponse.errorMessage
    };
};
exports.usePayData = usePayData;
const getPayDataItemsByDate = (getPayDataResponse, timeZone) => {
    var _a;
    const payDataItemsByDate = {};
    (_a = getPayDataResponse === null || getPayDataResponse === void 0 ? void 0 : getPayDataResponse.payDataItems) === null || _a === void 0 ? void 0 : _a.forEach((payDataItem) => {
        payDataItemsByDate[payDataItem.payDate] = Object.assign({}, getPayDataItemForSelfClassification(payDataItem, timeZone));
    });
    return payDataItemsByDate;
};
const getPayDataItemForSelfClassification = (originalPayDataItem, timeZone) => {
    const payDataItemForSelfClassification = Object.assign(Object.assign({}, originalPayDataItem), { payData: originalPayDataItem.payData.map(({ beginDateTime, endDateTime, salaryCodesDescription }) => {
            return {
                beginDateTime: (0, DateManagement_1.getSelfClassificationDateTimeString)(beginDateTime, timeZone),
                endDateTime: (0, DateManagement_1.getSelfClassificationDateTimeString)(endDateTime, timeZone),
                salaryCodesDescription
            };
        }) });
    return payDataItemForSelfClassification;
};
